module.exports = __webpack_public_path__ + "static/with_anchoring-9adcf06dde5952240338bcca2b497e62.gif";